import { createSelector } from '../../selectors'
import { modalCloseButtonHandler } from './constant'

const getButtons = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: modalCloseButtonHandler.selector.button }, true)

export const getModalCloseButtonHandlerComponents = () => ({
	buttons: getButtons(),
})
